let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fu0KO")).then(() => parcelRequire('2AmUl'));